import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './prompt-library.css';
import PromptBox from '../../elements/prompt-box/PromptBox';
import { promptLibraryData as data } from '../../../data/promptLibraryData';
import Dashboard from '../dashboard/Dashboard';

const PromptLibrary = () => {
  const location = useLocation();
  const [departmentIndex, setDepartmentIndex] = useState(null);
  const [taskIndex, setTaskIndex] = useState(null);
  const [prompts, setPrompts] = useState(null);
  
  useEffect(() => {
    setDepartmentIndex(null);
    setTaskIndex(null);
    setPrompts(null);
  }, [location]);
  
  useEffect(() => {
    setTaskIndex(null);
  }, [departmentIndex]);
  
  const handleDepartmentChange = (event) => {
    setDepartmentIndex(event.target.value);
  };
  
  const handleTaskChange = (event) => {
    setTaskIndex(event.target.value);
  };
  
  const setClipboard = (text) => {
    navigator.clipboard
      .writeText(text.prompt)
      .then(() => alert('Copied!'))
      .catch((err) =>
        alert('Error copying to clipboard: ' + err
        ));
  }
  
  const selectedDepartment = departmentIndex !== null ? data[departmentIndex] : null;
  const selectedTask = selectedDepartment && taskIndex !== null ? selectedDepartment.tasks[taskIndex] : null;
  
  useEffect(() => {
    selectedTask && selectedTask.prompts ? setPrompts(selectedTask.prompts) : setPrompts(null);
  }, [selectedTask]);
  
  const sidebarContent = <div className='dropdown-list-department'>
      <label htmlFor="department" className='paragraph-sub-4 text-dk'>Department</label>
      <select
        onChange={(e) => handleDepartmentChange(e)}
        className='dropdown-dk-purple'>
        <option defaultValue='Select'>Select Department</option>
        {data.map((item, index) => (
          <option key={index} value={index}>
            {item.department}
          </option>
        ))}
      </select>
    </div>;
  
  const contentBoxContent =
    <div className='content'>
    { selectedDepartment ?
      <div className='dropdown-list-task'>
        <label className='title-sub-3 semi-bold label-pad' htmlFor="task">
          Task
        </label>
        <select
          onChange={(e) => handleTaskChange(e)}
           value={taskIndex || ''}
           id="task"
          className='dropdown-dk-purple'
           >
          <option key='initialSelect'
            defaultValue='Select'>
            Select Task
          </option>
          {selectedDepartment &&
            selectedDepartment.tasks.map(((task, index) => (
            <option key={index}
              value={index}>
              {task.title}
            </option>
          )))}
        </select>
      </div>:
      <p className='light-bold'>This is the central hub where you can explore and select prompts tailored for various professional tasks and departments. The goal is to provide you with a seamless experience in finding the perfect prompts to enhance your communication in a corporate setting. <br/><br/><span className='sidebar-disclaimer-mobile'><span><strong>PLEASE NOTE</strong></span><br/> Before using any AI prompts or tools, we advise you to check with your organization's policies and guidelines regarding AI usage. Some companies may have specific rules or tools that are whitelisted or forbidden.<br/><br/></span><strong>Here's how the Prompt Library works:</strong> <br/><br/><strong>1. Department Dropdown:</strong> Start by selecting the department that aligns with your task. Choose from options such as Sales and Marketing, Customer Support, Human Resources, and more. <br/><br/><strong>2. Task Dropdown:</strong> Next, select the specific task or scenario you need a prompt for. This step ensures that the prompts presented to you are closely aligned with your requirements. <br/><br/><strong>3. Prompt:</strong> After choosing the task, you'll be presented a relevant prompt that will serve as a starting point for you to fine-tune to your specific needs. Each prompt will have a short title to help you quickly identify the most suitable option. <br/><br/><strong>4. Copy Prompt:</strong> Once you find a suitable prompt, simply click the 'Copy Prompt' button and the prompt will be saved to your clipboard for use. <br/><br/><strong>Documentation and Training:</strong> To assist you further, extensive documentation and training resources are provided to help maximize the usefulness of your selected prompt. These resources offer guidance on using prompts effectively and offer best practices for prompt design. <br/><br/>The Prompt Library is designed to be user-friendly and efficient, enabling you to find the ideal prompts for your professional needs. Explore the available options, customize as necessary, and make use of the comprehensive documentation and training materials. <br/><br/>Enjoy your experience in the Prompt Library!
      </p>
    }
    {selectedDepartment ?
      <ul className='prompt-list'>
        {prompts ?
          prompts.map((prompt, index) => (
            <PromptBox
              prompt={prompt}
              task={selectedTask}
              index={index}
              key={index}
              setClipboard={setClipboard}/>
          )) :
          <PromptBox
            prompt={null}
            task='Select Task'
            index='na'
            setClipboard={setClipboard}/>}
      </ul> :
      ''
    }
  </div>;
  
  return (
    <Dashboard
      content={sidebarContent}
      section='PROMPT LIBRARY'
      contentBoxContent={contentBoxContent}
      contentBoxSection={selectedDepartment?.department ? selectedDepartment.department : 'Welcome to the Prompt Library!'}
      department={selectedDepartment?.department}
      prompts={prompts}
    />
  );
};

export default PromptLibrary;
